export const asyncDelay = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));
